import React from "react"
import Editor from "react-simple-code-editor"
import { highlight, languages } from "prismjs/components/prism-core"
import "prismjs/components/prism-clike"
import "prismjs/components/prism-javascript"
import "prismjs/components/prism-markup"
import "./styles.css"
import "prismjs/components/prism-jsx"
import strings from "../../../localization/strings"
import { red500 } from "material-ui/styles/colors"
interface IProps {
    scriptCode: string
    errorScriptCode?: string
    handleChange(scriptCode: string): void
    scriptLabel?: string
}

const ScriptCodeEditor: React.SFC<IProps> = (props: IProps) => {
    const hightlightWithLineNumbers = (input, language) =>
    highlight(input, language)
      .split("\n")
      .map((line, i) => `<span class='editorLineNumber'>${i + 1}</span>${line}`)
      .join("\n");

    return (
        <div data-intercom-target={"Entry-CodeEditor"} className="container_editor_area">
            <div style={{ marginBottom: 5 }}>
                <span>{props.scriptLabel ? props.scriptLabel : "C# Script"}</span>
                {props.errorScriptCode &&
                    <span style={{ marginLeft: 10, color: red500, fontSize: 12 }}>{props.errorScriptCode}</span>
                }
            </div>
            <Editor
                placeholder={strings.Type_script_code}
                value={props.scriptCode}
                onValueChange={props.handleChange}
                highlight={code => hightlightWithLineNumbers(code, languages.jsx)}
                padding={10}
                className="container__editor"
            />
        </div>
    )
}

export default ScriptCodeEditor